import { UploadDetailesGetResponse } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiProperty, ApiTags } from "@nestjs/swagger";
import { UploadDetailesResponse } from "libs/shared-models/hrms/src/lib/hrms-upload-detailes/upload.detailes.response";
import { UploadDetailesDto } from "./Dto/upload.detailes.dto";
import { UploadDetailesService } from "./upload.detailes.service";

@ApiTags('uploadDeatailes')
@Controller('uploadDetailes')
export class UploadDetailesController {

    constructor(
        private service: UploadDetailesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }


    @Post('/createUploadDetailes')

    async createUploadDetailes(@Body() DTO: UploadDetailesDto,): Promise<UploadDetailesResponse> {
        try {
            return await this.service.createUploadDetailes(DTO);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(UploadDetailesResponse, error);
        }
    }

    @Post('/getUploadDetailes')
    async getUploadDetailes(): Promise<UploadDetailesGetResponse> {

        try {
            return this.service.getUploadDetailes();
        } catch (error) {

            return this.applicationExceptionHandler.returnException(UploadDetailesGetResponse, error)

        }

    }


}